import React, { useCallback } from "react";
import styled from "styled-components";
import { globalTheme } from "@clds/component-theme";
import { RadioGroup } from "@clds/radio";
import { InlineFieldLayout, Label } from "@cld/form";
import t from "common/i18n";
import { useFilterParams } from "../../selectors";
import { LICENSE_TYPE_OPTIONS } from "../../filterConsts";
import { SectionBox } from "./Filters.styles";

const InlineFieldLayoutCustomized = styled(InlineFieldLayout)`
	padding-bottom: ${globalTheme.spacing.xs};
`;
const RadioLabel = styled(Label)`
	padding-top: 1px; // aligment fix
`;

export default ({ handleSearch, source }) => {
	const { licenseType } = useFilterParams(source);
	const options = LICENSE_TYPE_OPTIONS.map((value: string) => ({ label: t(`${source}.filters.license.${value}`), value }));

	const filterChange = useCallback((item) => {
		handleSearch({
			filters: {
				licenseType: item
			}
		});
	}, [handleSearch]);


	return (<SectionBox data-test="license-type-section">
		<label>{t(`${source}.filters.license.label`)}</label>
		<RadioGroup name="radio-group" value={licenseType} onChange={filterChange}>
			{options.map((item) => (
				<InlineFieldLayoutCustomized key={item.value} label={<RadioLabel htmlFor={item.value} data-test={item.value}>{item.label}</RadioLabel>}>
					<RadioGroup.Radio id={item.value} value={item.value} />
				</InlineFieldLayoutCustomized>
			))}
		</RadioGroup>
	</SectionBox>);
};
